// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"ba3ed233","513":"923bb559","787":"6d519604"}[chunkId] + ".chunk.js";
};